import { motion } from "framer-motion";
import { HeartHandshake, PawPrint, Utensils, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const highlights = [
  { icon: PawPrint, label: "Animal Shelters", desc: "Adopt, foster, or support rescue pets" },
  { icon: HeartHandshake, label: "Charities", desc: "Donate in a loved one's name" },
  { icon: Utensils, label: "Food Rescue", desc: "Help fight hunger and food waste" },
];

const GivingBackTeaser = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <HeartHandshake className="h-10 w-10 text-primary mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Giving back, together
          </h2>
          <p className="text-muted-foreground mb-10 max-w-2xl mx-auto">
            Sometimes the best gift isn't something you can wrap. These are Australian charities, shelters,
            and community organisations doing incredible work — and you can support them right from your wishlist.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
          {highlights.map((h, i) => (
            <motion.div
              key={h.label}
              className="bg-card rounded-2xl p-6 border border-border card-elevated"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mx-auto mb-3">
                <h.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-bold text-foreground mb-1">{h.label}</h3>
              <p className="text-sm text-muted-foreground">{h.desc}</p>
            </motion.div>
          ))}
        </div>

        <Button asChild variant="outline" className="gap-2 rounded-full px-6">
          <Link to="/community">
            Explore Organisations <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default GivingBackTeaser;